import ReactCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/scss/alice-carousel.scss';
import { BaseCarouselProps } from './BaseCarousel.types';

export const BaseCarousel = ({
    name,
    items,
    autoPlay,
    disableButtonsControls,
    disableDotsControls,
    disableSlideInfo,
    infinite,
    autoPlayInterval,
}: BaseCarouselProps) => {
    return (
        <ReactCarousel
            name={name}
            items={items}
            autoPlay={autoPlay}
            disableButtonsControls={disableButtonsControls}
            disableDotsControls={disableDotsControls}
            disableSlideInfo={disableSlideInfo}
            infinite={infinite}
            autoPlayInterval={autoPlayInterval}
        />
    );
};